<dx-popup
    #vendorChecklistPopup
    minWidth="150px"
    minHeight="150px"
    width="50%"
    height="40%"
    title="AAPWF Checklist"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <dx-data-grid
                    #checkListItemGrid
                    width="100%"
                    height="100%"
                    keyExpr="id"
                    [highlightChanges]="true"
                    [repaintChangesOnly]="true"
                    [allowColumnReordering]="true"
                    [allowColumnResizing]="true"
                    [showBorders]="true"
                    [showColumnLines]="true"
                    [showRowLines]="true"
                    [dataSource]="checklistItems"
                >
                    <dxo-editing
                        mode="cell"
                        refreshMode="full"
                        [selectTextOnEditStart]="true"
                        [allowUpdating]="true"
                        [useIcons]="true"
                    ></dxo-editing>

                    <dxi-column
                        dataField="title"
                        dataType="string"
                        caption="Checklist Item"
                        [allowEditing]="false"
                    ></dxi-column>

                    <dxi-column
                        dataField="helpId"
                        dataType="string"
                        caption="Help"
                        cellTemplate="helpTemplate"
                        [allowEditing]="false"
                    ></dxi-column>

                    <dxi-column
                        dataField="camStatus"
                        dataType="string"
                        caption="MGR Status"
                        editCellTemplate="statusTemplate"
                        width="90"
                        [allowSorting]="!viewOnly"
                        [allowEditing]="!viewOnly && !isAccountStep"
                        [showEditorAlways]="!viewOnly && !isAccountStep"
                    ></dxi-column>

                    <dxi-column
                        dataField="camComments"
                        dataType="string"
                        caption="MGR Comment"
                        editCellTemplate="commentTemplate"
                        width="120"
                        [allowSorting]="!viewOnly"
                        [allowEditing]="!viewOnly && !isAccountStep"
                        [showEditorAlways]="!viewOnly && !isAccountStep"
                    ></dxi-column>

                    <ng-container *ngIf="isAccountStep">
                        <dxi-column
                            dataField="acctStatus"
                            dataType="string"
                            caption="ACCT Status"
                            editCellTemplate="statusTemplate"
                            width="90"
                            [allowSorting]="!viewOnly"
                            [allowEditing]="!viewOnly && isAccountStep"
                            [showEditorAlways]="!viewOnly && isAccountStep"
                        ></dxi-column>

                        <dxi-column
                            dataField="acctComments"
                            dataType="string"
                            caption="ACCT Comment"
                            editCellTemplate="commentTemplate"
                            width="120"
                            [allowSorting]="!viewOnly"
                            [allowEditing]="!viewOnly && isAccountStep"
                            [showEditorAlways]="!viewOnly && isAccountStep"
                        ></dxi-column>
                    </ng-container>

                    <div *dxTemplate="let item of 'helpTemplate'">
                        <ng-container *ngIf="item.data.helpId">
                            <a href="javascript:void(0)" (click)="onCheckListItemClick(item.data)">
                                <i class="cc-1-5x dx-theme-accent-as-text-color" [ngClass]="iconHelp"></i>
                            </a>
                        </ng-container>
                    </div>

                    <div *dxTemplate="let cellInfo of 'statusTemplate'">
                        <dx-select-box
                            [dataSource]="cellInfo.data.allowedStatusOptionCodes"
                            [(value)]="cellInfo.value"
                            (onValueChanged)="onStatusValueChanged($event, cellInfo)"
                        ></dx-select-box>
                    </div>

                    <div *dxTemplate="let cellInfo of 'commentTemplate'">
                        <dx-text-box
                            [(value)]="cellInfo.value"
                            (onValueChanged)="onCommentsValueChanged($event, cellInfo)"
                        ></dx-text-box>
                    </div>
                </dx-data-grid>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%" class="button-toolbar">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    [icon]="iconClose"
                                    (onClick)="onCloseClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>

                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Confirm"
                                    [icon]="iconCheck"
                                    (onClick)="onConfirmClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
